import { createSlice } from "@reduxjs/toolkit";
import { FirestoreService } from "../../../../shared/api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../../shared/api/firebase/references";
import { CmmFormConfigModel } from "../../../data-model/cmmFormConfigModel";
import { AppDispatch } from "../../store/store";

export interface MedicalPaFormConfigSliceModel {
  data?: CmmFormConfigModel[];
  loading: boolean;
  error: string | null;
}

const initialState: MedicalPaFormConfigSliceModel = {
  data: undefined,
  loading: false,
  error: null,
};

const medicalPaFormConfigSlice = createSlice({
  name: "medicalPaFormConfigSlice",
  initialState,
  reducers: {
    fetchMedicalPaFormConfigStart(state) {
      state.loading = true;
      state.error = null;
      state.data = undefined;
    },
    fetchMedicalPaFormConfigSuccess(state, action) {
      state.data = action.payload;
      state.loading = false;
    },
    fetchMedicalPaFormConfigFailure(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    resetMedicalPaFormConfig(state) {
      state.data = undefined;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchMedicalPaFormConfigStart,
  fetchMedicalPaFormConfigSuccess,
  fetchMedicalPaFormConfigFailure,
  resetMedicalPaFormConfig,
} = medicalPaFormConfigSlice.actions;

export const fetchMedicalPaFormConfig = () => async (dispatch: AppDispatch) => {
  dispatch(fetchMedicalPaFormConfigStart());
  try {
    const response = await FirestoreService.getAllDocuments(
      FirestoreCollectionReference.medicalPaFormConfig(),
    );
    dispatch(fetchMedicalPaFormConfigSuccess(response));
  } catch (error) {
    dispatch(fetchMedicalPaFormConfigFailure(error as string));
  }
};

export default medicalPaFormConfigSlice.reducer;
